import React, { useState, useEffect } from 'react'
import {
  TextField,
  Box,
  IconButton,
  Tooltip,
  Button,
  Typography,
} from '@material-ui/core'
import { Clear as ClearIcon } from '@material-ui/icons'
import { useTrans } from '../../../../services/i18n'
import { IS_BETWEEN } from '../../../../constants/filter'
import connect from '../connect'

const UpdatedAtFilter = ({ filters, onChangeFilters }) => {
  const { trans } = useTrans()
  const [fromDate, setFromDate] = useState('')
  const [toDate, setToDate] = useState('')
  const [dateError, setDateError] = useState('')

  // Initialize from filters
  useEffect(() => {
    const currentFilter = filters?.fields?.updatedAt?.value || {}
    setFromDate(currentFilter.from ? currentFilter.from.split('T')[0] : '')
    setToDate(currentFilter.to ? currentFilter.to.split('T')[0] : '')
  }, [filters?.fields?.updatedAt?.value])

  const validateDateRange = (from, to) => {
    if (from && to) {
      const fromDate = new Date(from)
      const toDate = new Date(to)
      if (fromDate > toDate) {
        return trans('from-date-cannot-be-after-to-date')
      }
    }
    return ''
  }

  const handleFromDateChange = (event) => {
    const newFromDate = event.target.value
    setFromDate(newFromDate)
    const error = validateDateRange(newFromDate, toDate)
    setDateError(error)
  }

  const handleToDateChange = (event) => {
    const newToDate = event.target.value
    setToDate(newToDate)
    const error = validateDateRange(fromDate, newToDate)
    setDateError(error)
  }

  const handleApplyFilter = () => {
    if (dateError) return

    // Only update filter if at least one date is selected
    if (fromDate || toDate) {
      onChangeFilters({
        updatedAt: {
          type: IS_BETWEEN,
          value: {
            from: fromDate ? `${fromDate}T00:00:00.000Z` : null,
            to: toDate ? `${toDate}T23:59:59.999Z` : null,
          },
        },
      })
    } else {
      // Clear filter if both dates are empty
      onChangeFilters({
        updatedAt: {
          type: IS_BETWEEN,
          value: {
            from: null,
            to: null,
          },
        },
      })
    }
  }

  const handleClear = () => {
    setFromDate('')
    setToDate('')
    setDateError('')
    onChangeFilters({
      updatedAt: {
        type: IS_BETWEEN,
        value: {
          from: null,
          to: null,
        },
      },
    })
  }

  const hasFilter = fromDate || toDate
  const canApply = (fromDate || toDate) && !dateError

  return (
    <Box>
      <Box display="flex" alignItems="center" gap={1.5}>
        <TextField
          size="small"
          variant="outlined"
          type="date"
          label={trans('updated-from')}
          value={fromDate}
          onChange={handleFromDateChange}
          InputLabelProps={{ shrink: true }}
          style={{ width: 150, marginRight: 10 }}
          error={!!dateError}
        />

        <TextField
          size="small"
          variant="outlined"
          type="date"
          label={trans('updated-to')}
          value={toDate}
          onChange={handleToDateChange}
          InputLabelProps={{ shrink: true }}
          style={{ width: 150, marginRight: 10 }}
          error={!!dateError}
        />

        <Button
          variant="outlined"
          color="primary"
          size="small"
          onClick={handleApplyFilter}
          disabled={!canApply}
          style={{
            minWidth: 80,
            textTransform: 'none',
            fontWeight: 600
          }}
        >
          {trans('apply') || 'Apply'}
        </Button>

        {hasFilter && (
          <Tooltip title={trans('clear-date-filter')}>
            <IconButton size="small" onClick={handleClear}>
              <ClearIcon />
            </IconButton>
          </Tooltip>
        )}
      </Box>

      {dateError && (
        <Box mt={0.5}>
          <Typography variant="caption" color="error" style={{ fontSize: '0.75rem' }}>
            {dateError}
          </Typography>
        </Box>
      )}
    </Box>
  )
}

export default connect(UpdatedAtFilter)
